import React from "react";

// components
import Paginate from "../../../components/ui/paginate";
import IBlogCard from "../misc/BlogCard";

// state and service
import { get_blogs } from "../../../service/api/blog";
import { onNext, onBack } from "../../../store/slices/blog";
import { useAppDispatch, useAppSelector } from "../../../store";
import CustomHeader from "../../../components/ui/CustomHeader/CustomHeader";
// import ArrowButton from "../../../components/ui/links/ArrowButton";

const BlogDashboard = () => {
  const dispatch = useAppDispatch();
  const current_page = useAppSelector(({ blog }) => blog.current_page);
  const last_page = useAppSelector(({ blog }) => blog.last_page);
  const blogs = useAppSelector(({ blog }) => blog.blogs);

  const onLoad = React.useCallback(() => {
    get_blogs(dispatch, current_page);
  }, [current_page, dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);
  // Filter only published blogs (where published === "1")
  const publishedBlogs = blogs.filter((item) => item.published === "1");

  return (
    <main className="h-full">
      <section className="py-12 md:py-24 lg:py-32 bg-primary-900">
        <div className="max-w-7xl flex items-center px-6 xl:px-0 pt-20 mx-auto text-center">
          <CustomHeader
            title="Corporate Setup Blog"
            description="Stay up to date with our latest news and updates."
            titleColor="text-white"
            descriptionColor="text-white"
          />
        </div>
      </section>

      <section className="py-12 md:py-24 lg:py-32 bg-customgreen">
        <div className="max-w-7xl mx-auto px-6 xl:px-0">
          <h3 className="text-2xl md:text-3xl lg:text-4xl text-primary-900 text-center font-bold mb-8">
            Latest From Our Blog
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {publishedBlogs.length > 0 ? (
              publishedBlogs.map((item) => (
                <IBlogCard key={item.id} item={item} />
              ))
            ) : (
              <div className="col-span-full text-center py-12">
                <p className="text-primary-600 text-lg">
                  No published blogs available at the moment.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Paginate
        current_page={current_page}
        last_page={last_page}
        onNext={() => dispatch(onNext())}
        onBack={() => dispatch(onBack())}
      />
    </main>
  );
};

export default BlogDashboard;
